import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

// The page is gated by the `sdui-preview` feature flag, declared with the
// app's other flags in packages/app/src/App.tsx and named in
// packages/app/src/hooks/config.ts.
export const sduiPreviewPlugin = createPlugin({
  id: 'sdui-preview',
  routes: {
    root: rootRouteRef,
  },
});

export const SduiPreviewPage = sduiPreviewPlugin.provide(
  createRoutableExtension({
    name: 'SduiPreviewPage',
    component: () =>
      import('./components/SduiPreviewPage').then(m => m.SduiPreviewPage),
    mountPoint: rootRouteRef,
  }),
);
